// extracted by mini-css-extract-plugin
module.exports = {"bubble":"LinkedInBubble_bubble__2XI29","face":"LinkedInBubble_face__2k30y","icon":"LinkedInBubble_icon__2Hm7X"};